import { AuthProvider } from './context';
import { Router } from './router';

const App = () => {
  return (
    <AuthProvider>
      <Router />
    </AuthProvider>
  );
};

export default App;
